var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#4b4b4b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-boxes-icon lucide-boxes",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 16.5-4.74-2.85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7 16.5 5-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5v5.17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m17 16.5-5-3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m17 16.5 4.74-2.85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5v5.17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8 7.26 5.15"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m12 8 4.74-2.85"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5V8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsDark);
export default __webpack_public_path__ + "static/media/groups_dark.79623d6402007712521a8ad50b9e5862.svg";
export { ForwardRef as ReactComponent };